module.exports = __webpack_public_path__ + "img/noPicture.f23ad36d.jpg";